import { useState } from 'react';

/**
 * A client's logo, served from the mounted branding directory rather than baked into the
 * image - the same arrangement as the login background, so one image still serves every
 * client and rebranding is a file swap.
 *
 * There is no config flag for "this deployment has a logo". The image either resolves from
 * the mount or it does not, and onError removes it, so a deployment that mounts nothing
 * simply shows no mark instead of a broken-image icon. That keeps the logo out of the four
 * places a config variable would otherwise have to be kept in step.
 *
 * alt is empty because these are decorative: the client's name is not known to the app, and
 * announcing "logo" adds nothing for a screen reader.
 */
function BrandMark({ src, style, className }) {
    const [failed, setFailed] = useState(false);

    if (failed) {
        return null;
    }

    return (
        <img
            src={src}
            alt=""
            style={style}
            className={className}
            onError={() => setFailed(true)}
        />
    );
}

export default BrandMark;
